import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactGA from 'react-ga';
import './Contact.css';
import { FaPhoneVolume } from "react-icons/fa6";
const Contact = () => {
  const [status, setStatus] = useState("Submit");
    const navigate = useNavigate();
    const [info, setInfo] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
    });
    useEffect(() => {
        ReactGA.pageview(window.location.pathname);
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        if (name === 'name') {
            newValue = value.replace(/[^a-zA-Z\s]/g, '');
        } else if (name === 'phone') {
            newValue = value.replace(/\D/g, '').slice(0, 10);
        }
        setInfo({
            ...info,
            [name]: newValue,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Submitting...");
        ReactGA.event({
            category: "contact us",
            action: "Submit button click",
            value: 1,
        });
        try {
            let response = await fetch('/api/contact', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(info),
            });
            if (response.ok) {
                setStatus("Submitted");
                setInfo({ name: "", phone: "", email: "", message: "" });
                navigate("/thankyou");
            } else {
                const errorMessage = await response.text();
                console.error("Error submitting form:", errorMessage);
                setStatus("Submit");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setStatus("Submit");
        }
    };
  return (
    <div className='main'>  
<section class="elementor-section elementor-inner-section elementor-element elementor-element-40c4e4c elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="40c4e4c" data-element_type="section" data-settings="{&quot;wdt_bg_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;wdt_bg_image_laptop&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;wdt_bg_image_tablet_extra&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;wdt_bg_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;wdt_bg_image_mobile_extra&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;wdt_bg_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;wdt_bg_position&quot;:&quot;center center&quot;,&quot;wdt_animation_effect&quot;:&quot;none&quot;}">
						<div class="elementor-container elementor-column-gap-no">
					<div class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-f8edbb3 animated-fast animated bounceInLeft" data-id="f8edbb3" data-element_type="column" data-settings="{&quot;animation&quot;:&quot;bounceInLeft&quot;,&quot;animation_delay&quot;:100}">
			<div class="elementor-widget-wrap elementor-element-populated">
						<div class="elementor-element elementor-element-7e7ffb8 elementor-widget_width-auto elementor-widget-tablet_width-inherit elementor-view-default elementor-widget elementor-widget-icon" data-id="7e7ffb8" data-element_type="widget" data-settings="{&quot;wdt_animation_effect&quot;:&quot;none&quot;}" data-widget_type="icon.default">
				<div class="elementor-widget-container">
				
        <div class="elementor-element elementor-element-6119b5c elementor-widget_width-initial elementor-widget-mobile_width-inherit elementor-widget elementor-widget-wdt-heading" data-id="6119b5c" data-element_type="widget" data-settings="{&quot;wdt_animation_effect&quot;:&quot;none&quot;}" data-widget_type="wdt-heading.default">
				<div class="elementor-widget-container">
			<div class="wdt-heading-holder" id="wdt-heading-6119b5c">
        <h2 class="wdt-heading-title-wrapper-deco wdt-heading-align-center wdt-heading-deco-wrapper">
          <span class="wdt-heading-title-wrapper-decosupport"><h2 ><FaPhoneVolume />   We're Here To Provide Support</h2></span></h2></div>		</div>
				</div>
				</div>
				</div>
					</div>
		</div>
				<div class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-95e8431 animated-fast animated bounceInRight" data-id="95e8431" data-element_type="column" data-settings="{&quot;animation&quot;:&quot;bounceInRight&quot;,&quot;animation_delay&quot;:100}">
			<div class="elementor-widget-wrap elementor-element-populated">
						<div class="elementor-element elementor-element-194351d elementor-widget_width-initial elementor-widget-laptopwidth-inherit elementor-widget-tabletwidth-initial elementor-widget-mobile_extra_width-inherit elementor-widget elementor-widget-text-editor" data-id="194351d" data-element_type="widget" data-settings="{&quot;wdt_animation_effect&quot;:&quot;none&quot;}" data-widget_type="text-editor.default">
				<div class="elementor-widget-container-paragraph">
		
                <p>We're excited to connect with you! Whether you have a question, feedback, or just want to chat, feel free to reach out to us. Our team is here to assist you with any inquiries you may have.</p>
                <p>Looking forward to hearing from you soon!</p>	
                			</div>
				</div>
					</div>
		</div>
					</div>
		</section>
         <div className="contact-container">
<form onSubmit={handleSubmit} className="contact-form">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                        <label htmlFor="name">Your Name</label>
                                            <input type="text" className="form-control" id="name" name="name" value={info.name} onChange={handleChange} placeholder="Your Name" required />
                                           
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                        <label htmlFor="phone">Your Phone</label>
                                            <input type="text" className="form-control" id="phone" name="phone" value={info.phone} onChange={handleChange} placeholder="Your Phone" required />
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                        <label htmlFor="email">Your Email</label>
                                            <input type="text" className="form-control" id="email" name="email" value={info.email} onChange={handleChange} placeholder="Your Email" required />
                                           
                                        </div>
                                    </div>
                                   
                                    <div className="col-12">
                                        <div className="form-floating">
                                        <label htmlFor="message">Message</label>
                                            <textarea className="form-control" id="message" name="message" value={info.message} onChange={handleChange} placeholder="Your Message" style={{ height: "150px" }} required></textarea>
                                            
                                        </div>
                                    </div>
                                    <div className="col-12">
                                    <div className="form-floating">
                                        <button className="btn btn-primary py-3 px-5" type="submit">{status}</button>
                                    </div>
                                    </div>
                                </div>
                            </form>
                <div className="contact-info1">
                    <h2>Say Hello!</h2>
                    <p>We would love to hear from you! Whether you have a question about our services, need assistance, or just want to talk, we are here to help</p>
                    <img 
                        src="./pic5.jpg" 
                        alt="Say Hello" 
                        className="info-image" 
                    />
                    <h3>Enquiries</h3>
                    <p> <a href="mailto:ssvnbaripada@gmail.com">ssvnbaripada@gmail.com</a></p>
                    <div className="social-icons">
                    <a href='/'> <i className="fab fa-instagram"></i></a>
                     <a href='/'> <i className="fab fa-facebook"></i></a>
                        
                    </div>
                </div>
    </div>
    <div className="contact-container">   
      <div className="contact-card usa">
        <h2>Address</h2>
        <p>
          <i className="fa fa-map-marker"></i> Sahar Sahi, WN 08, Infront of Baripada ITI, Baripad, Mayaurbhanj, Odisha-757001
        </p>
        {/* <p>
          <i className="fa fa-phone"></i> +00-123456789
        </p>
        <p>
          <i className="fa fa-envelope"></i> info@example.com
        </p> */}
      </div>
      <div className="contact-card australia">
        <h2>Phone</h2>
        {/* <p>
          <i className="fa fa-map-marker"></i> 936 Kiehn Route, West Ned,
          Tennessee, Australia 11230
        </p> */}
        <p>
          <i className="fa fa-phone"></i> +91 7978523365/9437086696

        </p>
        {/* <p>
          <i className="fa fa-envelope"></i> contact@example.com
        </p> */}
      </div>
      <div className="contact-card canada">
        <h2>Email</h2>
        {/* <p>
          <i className="fa fa-map-marker"></i> 4059 Carling Avenue, Ottawa,
          Ontario, Canada, K1Z 7B5
        </p>
        <p>
          <i className="fa fa-phone"></i> +00123456789
        </p> */}
       <p>
  <i className="fa fa-envelope"></i>  
  <a href="mailto:ssvnbaripada@gmail.com">ssvnbaripada@gmail.com</a>
</p>

      </div>
      </div>
      <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="bg-light text-center h-100 p-5">
                                <div className="btn-square bg-white rounded-circle mx-auto mb-4">
                                    {/* <i className="fa fa-map-marker-alt fa-2x text-primary"></i> */}
                                    {/* <h4 className="adress">Office Address</h4> */}
                                </div>
                                
                    
                                <a className="btn btn-primary px-4" href="https://maps.app.goo.gl/nx9xveyCrY1KzLf77" target="_blank"></a>
                            </div>
                        </div>
                
                    {/* <div className="row mb-5">
                        <div className="col-12 wow fadeIn" data-wow-delay="0.1s">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d1555.940064355624!2d86.73289597611617!3d21.947234733552587!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDU2JzQ0LjYiTiA4NsKwNDMnNTcuOCJF!5e0!3m2!1sen!2sin!4v1723110149581!5m2!1sen!2sin" width="1750" height="450" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                             </div> </div>  */}
                              </div>
                              );};
export default Contact;